<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3333 2.66666H5.66667C3.644 2.66666 2 4.31066 2 6.33333V21.6667C2 22.0507 2.22 22.4013 2.56667 22.568C2.704 22.6347 2.852 22.6667 3 22.6667C3.22267 22.6667 3.444 22.592 3.62533 22.4467L8.35067 18.6667H18.3333C20.356 18.6667 22 17.0227 22 15V6.33333C22 4.31066 20.356 2.66666 18.3333 2.66666Z"/>
</svg>
